import { EnumOnereWithDettaglioDTOStato } from '@framework/api-client';
import { assertNever } from '@framework/engine';
import { t } from '@framework/i18n';
import { Tag, TagProps } from 'antd';
import * as React from 'react';
import styled, { DefaultTheme, useTheme } from 'styled-components';

const StyledTag = styled(Tag)<{ $mini?: boolean }>`
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: ${props => (props.$mini ? '14px' : '20px')};
  padding-inline: ${props => (props.$mini ? '4px' : '7px')};
  &&& {
    font-weight: 600;
  }
`;

/**
 * Ritorna le impostazioni per il tag
 *
 */
function getTagOptions(
  state: EnumOnereWithDettaglioDTOStato | undefined,
  theme?: DefaultTheme,
): TagProps {
  if (!state) return { color: '#a5c201', children: 'N/D' };
  switch (state) {
    case EnumOnereWithDettaglioDTOStato.DA_PAGARE:
      return {
        color: theme?.colorError ?? '#fe0000',
        children: t('burden-payment-state-tag.da-pagare', 'Da Pagare'),
      };
    case EnumOnereWithDettaglioDTOStato.ATTESA_PAGAMENTO:
      return {
        color: theme?.colorInfo ?? '#569bc4',
        children: t(
          'burden-payment-state-tag.attesa-pagamento',
          'Attesa Pagamento',
        ),
      };
    case EnumOnereWithDettaglioDTOStato.PAGATO:
      return {
        color: theme?.colorSuccess ?? '#389e0d',
        children: t('burden-payment-state-tag.pagato', 'Pagato'),
      };
    case EnumOnereWithDettaglioDTOStato.RICHIESTA_INTEGRAZIONE_PAGAMENTO:
      // color: '#4b4f4d',
      return {
        color: '#9E6C00', // theme?.colorWarning ?? '#faad14',
        children: t(
          'burden-payment-state-tag.pagato-parzialmente',
          'Pagato Parzialmente',
        ),
      };
  }
  assertNever(state);
}

export interface IBurdenPaymentStateTagProps {
  state?: EnumOnereWithDettaglioDTOStato | null;
  mini?: boolean;
}

/**
 * Stato dei Pagamenti di un Onere
 */
export function BurdenPaymentStateTag(props: IBurdenPaymentStateTagProps) {
  const { state, mini } = props;
  const theme = useTheme();

  if (!state) return null;

  return <StyledTag $mini={mini} {...getTagOptions(state, theme)} />;
}
